var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",class:{ dark: _vm.variant == 'dark' }},[_c('strong',[_vm._v(" КШДУ ")]),_c('span',[_vm._v("ім. Сергія Нижного")])])}
var staticRenderFns = []

export { render, staticRenderFns }